
import { Formik, FormikHelpers, FormikValues } from "formik"
import { ReactElement } from "react"

interface iValidationFormProps{
    initialValues:FormikValues,
    validationSchema: any,
    children: ReactElement,
    onSubmit: (values:any, resetForm:FormikHelpers<any>)=>any
}

export default function ValidationForm({initialValues, validationSchema, children, onSubmit}:iValidationFormProps) {
  return (
    <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
    >
        {
            ()=>(
                <>{children}</>
            )
        }
    </Formik>
  )
}
